import * as managerV3 from './m2m-cleaning.manager-v3';
import * as managerV4 from './m2m-cleaning.manager-v4';
import * as cleanerV4 from './m2m-cleaning.cleaner-v4';
export const m2mCleaning = {
  managerV3,
  managerV4,
  cleanerV4
};
